'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import { Suspense } from 'react';
import type { ApiVaultWarning } from '@/helpers/warningTypes';
import type { VaultV1Risk } from '@/lib/procedures/vaultV1Risk.contract';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import type { PendingTimelock } from '../VaultHeroPendingActions/types';
import { VaultConfigurationError, VaultConfigurationLoading } from './states';
import VaultConfigurationClient from './VaultConfiguration.client';
export interface VaultConfigurationLayoutProps {
  chainId: ChainId;
  curators: VaultV1Risk['curators'];
  curatorsPartial: boolean;
  factoryAddress: Address;
  timelock: number;
  creationTimestamp: number | null;
  warnings: ApiVaultWarning[];
  pendingTimelocks: PendingTimelock[];
}
const VaultConfigurationLayout = t0 => {
  const $ = _c(12);
  const {
    chainId,
    curators,
    curatorsPartial,
    factoryAddress,
    timelock,
    creationTimestamp,
    warnings,
    pendingTimelocks
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-foreground text-sm">Vault Configuration</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <VaultConfigurationError />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VaultConfigurationLoading />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== chainId || $[4] !== creationTimestamp || $[5] !== curators || $[6] !== curatorsPartial || $[7] !== factoryAddress || $[8] !== pendingTimelocks || $[9] !== timelock || $[10] !== warnings) {
    t4 = <div className="gap-sm flex flex-col" id="vault-configuration-section">{t1}<SectionErrorBoundary fallback={t2}><Suspense fallback={t3}><VaultConfigurationClient chainId={chainId} curators={curators} curatorsPartial={curatorsPartial} factoryAddress={factoryAddress} timelock={timelock} creationTimestamp={creationTimestamp} warnings={warnings} pendingTimelocks={pendingTimelocks} /></Suspense></SectionErrorBoundary></div>;
    $[3] = chainId;
    $[4] = creationTimestamp;
    $[5] = curators;
    $[6] = curatorsPartial;
    $[7] = factoryAddress;
    $[8] = pendingTimelocks;
    $[9] = timelock;
    $[10] = warnings;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default VaultConfigurationLayout;